export var GameModeTranslationKeyContext = /*#__PURE__*/ function(GameModeTranslationKeyContext) {
    GameModeTranslationKeyContext["BaseGame"] = "";
    GameModeTranslationKeyContext["Seafarers"] = "seafarers";
    GameModeTranslationKeyContext["CitiesAndKnights"] = "c&k";
    GameModeTranslationKeyContext["CitiesAndKnightsSeafarers"] = "c&kSeafarers";
    return GameModeTranslationKeyContext;
}({});
export function isCitiesAndKnightsContext(context) {
    return context === "c&k" || context === "c&kSeafarers";
}
